import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "title", "tabs", "activeTab", "onActiveTabChange", "button", "className", "layoutType", "backgroundColor", "titleTag", "data-test-id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useUncontrolledProp } from 'uncontrollable';
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { SiteVideo } from '@sbercloud/uikit-product-site-video';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { Tabs } from '@snack-uikit/tabs';
import { SectionTitle } from '../../helperComponents';
import { SectionBasic } from '../SectionBasic';
import styles from "./styles.module.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function TabIcon(_ref) {
  var icon = _ref.icon;
  if (icon && typeof icon === 'string') {
    return /*#__PURE__*/_jsx("img", {
      src: icon,
      alt: "",
      className: styles.tabIconImage
    });
  }
  return icon;
}
export function SectionContentTabs(_ref2) {
  var id = _ref2.id,
    title = _ref2.title,
    tabs = _ref2.tabs,
    activeTabProp = _ref2.activeTab,
    onActiveTabChange = _ref2.onActiveTabChange,
    button = _ref2.button,
    className = _ref2.className,
    layoutType = _ref2.layoutType,
    backgroundColor = _ref2.backgroundColor,
    titleTag = _ref2.titleTag,
    _ref2$dataTestId = _ref2['data-test-id'],
    dataTestId = _ref2$dataTestId === void 0 ? 'section-content-tabs' : _ref2$dataTestId,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useUncontrolledProp = useUncontrolledProp(activeTabProp, tabs[0].id, onActiveTabChange),
    _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
    activeTab = _useUncontrolledProp2[0],
    setActiveTab = _useUncontrolledProp2[1];
  var isDesktop = ['desktop', 'desktopSmall'].includes(layoutType);
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    layoutType: layoutType,
    title: title,
    className: className,
    backgroundColor: backgroundColor,
    "data-test-id": dataTestId,
    titleTag: titleTag
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsx(Tabs, {
      value: activeTab,
      onChange: setActiveTab,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.sectionContent,
        "data-layout-type": layoutType,
        children: [/*#__PURE__*/_jsxs("div", {
          className: cn(styles.tabsWrapper, _defineProperty({}, styles.desktopTabsWrapper, isDesktop)),
          children: [/*#__PURE__*/_jsx(Tabs.TabBar, {
            orientation: isDesktop ? 'vertical' : 'horizontal',
            markerPosition: isDesktop ? 'before' : 'after',
            className: cn(_defineProperty({}, styles.desktopTabs, isDesktop)),
            children: tabs.map(function (_ref3) {
              var id = _ref3.id,
                title = _ref3.title,
                disabled = _ref3.disabled,
                icon = _ref3.icon;
              return /*#__PURE__*/_jsx(Tabs.Tab, {
                value: id
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ,
                label: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(RichText, {
                    richText: title
                  }), /*#__PURE__*/_jsx(TabIcon, {
                    icon: icon
                  })]
                }),
                disabled: disabled
              }, id);
            })
          }), Boolean(button) && /*#__PURE__*/_jsx(ButtonFilled, _objectSpread(_objectSpread({}, button), {}, {
            fullWidth: !isDesktop,
            size: "l",
            "data-test-id": "".concat(dataTestId, "__button")
          }))]
        }), tabs.map(function (_ref4) {
          var id = _ref4.id,
            mediaTitle = _ref4.mediaTitle,
            mediaSubtitle = _ref4.mediaSubtitle,
            mediaDescription = _ref4.mediaDescription,
            image = _ref4.image,
            video = _ref4.video,
            onPlay = _ref4.onPlay;
          return /*#__PURE__*/_jsxs(Tabs.TabContent, {
            value: id,
            className: styles.mediaWrapper,
            children: [image && /*#__PURE__*/_jsx("div", {
              className: styles.imageWrapper,
              children: /*#__PURE__*/_jsx("img", {
                className: styles.image,
                src: image.src,
                alt: image.alt || title || 'section-content-image',
                "data-test-id": "".concat(dataTestId, "__image")
              })
            }), video && /*#__PURE__*/_jsx(SiteVideo, {
              video: video,
              onPlay: onPlay,
              layoutType: layoutType,
              "data-test-id": "".concat(dataTestId, "__video")
            }), (mediaTitle || mediaSubtitle) && /*#__PURE__*/_jsx(SectionTitle, {
              titleSectionSize: "s",
              layoutType: layoutType,
              title: mediaTitle,
              description: mediaSubtitle
            }), mediaDescription && /*#__PURE__*/_jsx(SectionTitle, {
              layoutType: layoutType,
              description: mediaDescription
            })]
          }, id);
        })]
      })
    })
  }));
}